export default "__VITE_ASSET__DTDYQUi___"